import script from "./draw.vue?vue&type=script&setup=true&lang=js"
export * from "./draw.vue?vue&type=script&setup=true&lang=js"

import "./draw.vue?vue&type=style&index=0&id=09d3cdf7&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d3cdf7"]])

export default __exports__